import { Clock, ArrowRight, BookOpen } from "lucide-react";
import { C } from "../../theme/tokens";
import { CourseMark } from "./CourseMark";
import { FoldedCorner } from "./FoldedCorner";

export function CourseListCard({ course, t, onOpen }) {
  return (
    <button
      onClick={onOpen}
      style={{
        position: "relative",
        overflow: "hidden",
        textAlign: "left",
        background: `linear-gradient(160deg, ${C.panel1} 0%, ${C.panel2} 130%)`,
        border: `1px solid ${C.hairline}`,
        borderRadius: 26,
        padding: 18,
        cursor: "pointer",
        width: "100%",
      }}
    >
      <CourseMark />
      <FoldedCorner />
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: "rgba(0,0,0,0.55)",
          border: `1px solid ${C.hairline}`,
          borderRadius: 20,
          padding: "6px 12px",
          fontSize: 12,
          color: C.primary,
        }}
      >
        <Clock size={13} color={C.secondary} /> {course.duration}
      </div>

      <div style={{ marginTop: 30, maxWidth: "78%" }}>
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            color: C.eduBright,
            fontSize: 12.5,
            fontWeight: 600,
            fontFamily: "'Space Grotesk', sans-serif",
          }}
        >
          <BookOpen size={13} /> {course.lessons.length} {t.edu_lesson_word}
        </div>
        <div
          style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontWeight: 700,
            fontSize: 21,
            color: C.primary,
            marginTop: 4,
            letterSpacing: "-0.01em",
          }}
        >
          {course.title}
        </div>
      </div>

      <div
        style={{
          position: "relative",
          zIndex: 1,
          marginTop: 14,
          marginLeft: "auto",
          width: 38,
          height: 38,
          borderRadius: "50%",
          background: `linear-gradient(135deg, ${C.edu} 0%, ${C.eduBright} 100%)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowRight size={17} color="#241705" />
      </div>
    </button>
  );
}
